import { Reducer } from 'redux';
import moment from 'moment';
import { v4 as createUUID } from 'uuid';
import { ProcessStepCodesEnum } from 'app/features/OnlineInsure/TravelInsurance/types';
import { TravelInsuranceState, TravelInsuranceActions, INSURE_TRAVEL_INSURANCE__SAVE_RECOMMEND_PLAN_DATA, INSURE_TRAVEL_INSURANCE__INIT_PROCESS_DONE, INSURE_TRAVEL_INSURANCE__SET_ACCESSIBLE_STEP, INSURE_TRAVEL_INSURANCE__SAVE_CALCULATION_PAGE_DATA, INSURE_TRAVEL_INSURANCE__SET_POLICY_STATUS, INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_PAGE_DATA, INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_CLAUSES_PAGE_DATA, INSURE_TRAVEL_INSURANCE__SEND_OTP_DONE, INSURE_TRAVEL_INSURANCE__RESEND_OTP_DONE, INSURE_TRAVEL_INSURANCE__SEND_POLICY_DONE, INSURE_TRAVEL_INSURANCE__UPDATE_CACHE, INSURE_TRAVEL_INSURANCE__RESET_CACHE } from './types';

const initialState: TravelInsuranceState = {
  static: {
    travelRegions: [],
    coverages: [],
    questionnaires: []
  },
  process: {
    accessibleSteps: [ProcessStepCodesEnum.Calculation],
    calculation: {},
    insuranceInfo: {
      clauses: {}
    },
    confirmInfo: {
      otpAuth: {}
    }
  }
};

const travelInsuranceReducer: Reducer<TravelInsuranceState, TravelInsuranceActions> = (state = initialState, action): TravelInsuranceState => {
  switch (action.type) {
    // 緩存方案內容資料 (資料來源：旅平險介紹頁，熱門推薦區塊內的方案)
    case INSURE_TRAVEL_INSURANCE__SAVE_RECOMMEND_PLAN_DATA: {
      return { ...state, recommendPlanData: action.payload.data };
    }
    // 初始化流程 (初始取得相關資料) 完成
    case INSURE_TRAVEL_INSURANCE__INIT_PROCESS_DONE: {
      return { ...state, static: { ...state.static, ...action.payload.response, paymentWSUUID: createUUID() } };
    }
    // 設置可訪問步驟
    case INSURE_TRAVEL_INSURANCE__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 緩存「計算保費」(Step-1) 資料
    case INSURE_TRAVEL_INSURANCE__SAVE_CALCULATION_PAGE_DATA: {
      return { ...state, process: { ...state.process, calculation: { ...state.process.calculation, data: action.payload.data } } };
    }
    // 設置保單狀態
    case INSURE_TRAVEL_INSURANCE__SET_POLICY_STATUS: {
      return { ...state, policyStatus: { ...state.policyStatus, ...action.payload.status } };
    }
    // 緩存「填寫資料」(Step-2-1) 資料
    case INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_PAGE_DATA: {
      return { ...state, process: { ...state.process, insuranceInfo: { ...state.process.insuranceInfo, data: action.payload.data } } };
    }
    // 緩存「填寫資料」(Step-2-2) 資料
    case INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_CLAUSES_PAGE_DATA: {
      return { ...state, process: { ...state.process, insuranceInfo: { ...state.process.insuranceInfo, clauses: { ...state.process.insuranceInfo.clauses, data: action.payload.data } } } };
    }
    // 發送 OTP 驗證碼 完成
    // 重新發送 OTP 驗證碼 完成
    case INSURE_TRAVEL_INSURANCE__SEND_OTP_DONE:
    case INSURE_TRAVEL_INSURANCE__RESEND_OTP_DONE: {
      return { ...state, process: { ...state.process, confirmInfo: { ...state.process.confirmInfo, otpAuth: { ...state.process.confirmInfo.otpAuth, otp: action.payload.response, approvedTime: moment().format('YYYY-MM-DD HH:mm:ss.SSS') } } } };
    }
    // 送出保單 (新增保單) 完成
    case INSURE_TRAVEL_INSURANCE__SEND_POLICY_DONE: {
      const accessibleSteps = [ProcessStepCodesEnum.Payment];
      return { ...state, process: { ...state.process, accessibleSteps }, policyInfo: { ...action.payload.response, premiumTotal: action.payload.premiumTotal } };
    }
    // 更新流程資料緩存
    case INSURE_TRAVEL_INSURANCE__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case INSURE_TRAVEL_INSURANCE__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default travelInsuranceReducer;
